import React from 'react'
import PropTypes from 'prop-types'
import { INSTRUMENT_EMPTY_VALUE, VISIT_DETAIL } from '../utils/constants'

const formatVisitValue = (value) =>
  value != null && value !== '' ? value : INSTRUMENT_EMPTY_VALUE

const VisitDetailContent = ({ visit, selectedDay }) => {
  const visitData = visit.visitData || {}

  const renderRow = (label, value) => (
    <div className='study-timeline-detail-row' key={label}>
      <span className='study-timeline-detail-label'>{label}:</span>
      <span className='study-timeline-detail-value'>{formatVisitValue(value)}</span>
    </div>
  )

  // Order: Name, Cycle, Anchor, Offset, Window, Study Day. No value → "-"
  return (
    <div className='study-timeline-detail-content'>
      {renderRow(VISIT_DETAIL.NAME, visit.label)}
      {renderRow(VISIT_DETAIL.CYCLE, visit.cycleName)}
      {renderRow(VISIT_DETAIL.ANCHOR, visitData.metadata?.deployment_option)}
      {renderRow(VISIT_DETAIL.OFFSET, visitData.day)}
      {renderRow(VISIT_DETAIL.WINDOW, visitData.window)}
      {renderRow(VISIT_DETAIL.STUDY_DAY, selectedDay)}
    </div>
  )
}

VisitDetailContent.propTypes = {
  visit: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    cycleName: PropTypes.string,
    visitData: PropTypes.object,
  }).isRequired,
  selectedDay: PropTypes.number.isRequired,
}

export default VisitDetailContent
